export interface PluginSettings {
    allowedOrigins: string;
    automaticOpen: boolean;
    automaticOpenTimeout: number;
    snooze: boolean;
    snoozeTime: number;
    backgroundColor: string;
    headerLogoUrl: string;
    minimizedPluginText: string;
    noAgentMessage: string;
    welcomeMessage: string;
    queueSelectionMessage: string;
    sessionClosedMessage: string;
    textColor: string;
}

export default class WebChat {
    static readonly FROM_SYSTEM = 'system';
}

export enum SupervisorEvent {
    addMessageBirdChannel = 'addMessageBirdChannel',
    addBirdChannel = 'addBirdChannel',
    removeMessageBirdChannel = 'removeMessageBirdChannel',
    removeBirdChannel = 'removeBirdChannel',
    messageBirdIntegrationChanged = 'messageBirdIntegrationChanged',

    birdIntegrationChanged = 'birdIntegrationChanged',
}

export enum AgentEvent {
    agentBecameAvailable = 'agentBecameAvailable',
    agentLogout = 'agentLogout',
    agentSubscribed = 'agentSubscribed',
    agentUnsubscribed = 'agentUnsubscribed',
    closingStartedByAgent = 'closingStartedByAgent',
    messageSendingStarted = 'messageSendingStarted',
    queueInfoRequested = 'queueInfoRequested',
    transferStartedByAgent = 'transferStartedByAgent',
    ticketAssigned = 'ticketAssigned',
}
export enum XASEvent {
    refreshChatQueues = 'refreshChatQueues',
    transferChatSessionsAfterQueueDelete = 'transferChatSessionsAfterQueueDelete',
}
export enum PluginEvent {
    messageSendingStarted = 'messageSendingStarted',
    pluginConnected = 'pluginConnected',
}
export enum ServerEvent {
    agentAdded = 'agentAdded',
    agentLeft = 'agentLeft',
    messageAccepted = 'messageAccepted',
    pluginDisconnected = 'pluginDisconnected',
    pluginInitializationFailed = 'pluginInitializationFailed',
    pluginInitialized = 'pluginInitialized',
    queueInfo = 'queueInfo',
    serverStarted = 'serverStarted',
    sessionClosingFailed = 'sessionClosingFailed',
    sessionFinished = 'sessionFinished',
    sessionStarted = 'sessionStarted',
    sessionTransferred = 'sessionTransferred',
    transferFailed = 'transferFailed',
    transferSuccessful = 'transferSuccessful',
    messageBirdChannelAdded = 'messageBirdChannelAdded',
    messageBirdChannelAddFailed = 'messageBirdChannelAddFailed',
    messageBirdChannelRemoved = 'messageBirdChannelRemoved',
    messageBirdChannelRemoveFailed = 'messageBirdChannelRemoveFailed',
}

export function sleep(ms: number) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

export function isInBrowser() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
}
